<template>
  <b-container>
    <b-row class="footer">
      <b-col>
        <h4>Instacash Blog</h4>
        <v-list dense color="#793980">
          <v-list-item href="https://g.page/instacash529?share" target="_blank">
            <v-icon class="pr-2 ">mdi-map</v-icon>Rivera Indarte 529
          </v-list-item>
          <v-list-item><v-icon class="pr-2">mdi-clock</v-icon>Lunes - Viernes: 9:00 - 20:00hs <br/> Sábados: 9:00 - 15:00hs</v-list-item>
          <v-list-item
            href="mailto:info@instacash.com.ar?Subject=Contacto+desde+Web+-+Instacash%21"
            target="_blank"
          ><v-icon class="pr-2">mdi-mail</v-icon>info@instacash.com.ar</v-list-item>
        </v-list>
      </b-col>
      <b-col>
        <h4>Categorias</h4>
        <v-list dense color="#793980">
          <v-list-item
            :href="categoria.nombre"
            v-for="categoria in categorias"
            :key="categoria.nombre"
          >{{categoria.nombre}}</v-list-item>
        </v-list>
      </b-col>
      <b-col>
        <h4>Seguinos</h4>
        <div align-h="between">
          <v-btn icon href="https://www.facebook.com/InstaCash.ar/" target="_blank">
            <v-icon class="amarrs">mdi-facebook</v-icon>
          </v-btn>
          <v-btn icon class="mx-5" href="https://www.instagram.com/instacash.ar/" target="_blank">
            <v-icon class="amarrs">mdi-instagram</v-icon>
          </v-btn>
        </div>
      </b-col>
    </b-row>
    <b-row class="footerfoot p-0">
      <b-col>
        <p class="amarrs">© Instacash 2020</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
   mounted() {
     this.$store.dispatch("categorias/listarCategorias");
  },
  computed: {
    categorias() {
      return this.$store.getters["categorias/verCategorias"];
    }
  }
};
</script>